import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { constants } from './shared/constants';

@Injectable({
    providedIn: 'root',
})
export class AppApi {
    constructor(private http: HttpClient) { }

    getCompany(): Observable<any> {
        return this.http.get(`${environment.prospektr_buy_backend_base_url}${constants.getCompany}`);
    }

}
